import useArchiveEstimate from '@/api/mutations/estimates/useArchiveEstimate';
import { Button, Modal, ModalProps } from '@payaca/ambrosia';
import { FC } from 'react';

type ArchiveEstimateModalProps = {
  projectId: string;
  estimateId: string;
  isSent: boolean;
  onArchived?: () => void;
} & Omit<ModalProps, 'title'>;

const ArchiveEstimateModal: FC<ArchiveEstimateModalProps> = (props) => {
  const { projectId, estimateId, isSent, onArchived, onClose, ...rest } = props;

  const { mutate, isPending } = useArchiveEstimate({
    projectId,
    options: {
      onSuccess: () => {
        onArchived?.();
        onClose?.();
      },
    },
  });

  return (
    <Modal {...rest} onClose={onClose} title="Archive estimate">
      <Modal.Body>
        <p>
          {isSent
            ? 'This estimate will be archived. The client portal link will stop working until you unarchive it.'
            : "This estimate will be archived. You won't be able to edit it or send it to the customer until you unarchive it."}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button
            onClick={() => mutate({ id: estimateId })}
            isProcessing={isPending}
            disabled={isPending}
            colour="negative"
          >
            Archive estimate
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default ArchiveEstimateModal;
